import type {
  SolutionSystem,
  SolutionSystems
} from '@common/api/graphql/getSolutionSystemsGql';
import {
  isApiSolutionSystem,
  isBulkSolutionSystem
} from '@console/common/solutionSystem';
import type { AppState } from '@console/reducers';
import { createSelector } from 'reselect';

const getSolutionSystems = (state: AppState): SolutionSystems =>
  state.solutionSystems;

export const getBulkSolutionSystem = createSelector(
  [getSolutionSystems],
  (solutionSystems): SolutionSystem | undefined =>
    solutionSystems.find(solutionSystem => isBulkSolutionSystem(solutionSystem))
);
export const getApiSolutionSystem = createSelector(
  [getSolutionSystems],
  (solutionSystems): SolutionSystem | undefined =>
    solutionSystems.find(solutionSystem => isApiSolutionSystem(solutionSystem))
);
